define('common/module/realtime/Serum.SseEventEmitter',[
  'common/module/realtime/Serum.RealtimeEventEmitter',
  'jquery',
  'common/js/lib/Serum.Pubsub',
  'module'
], function(RealtimeEventEmitter, $, Pubsub, module) {

  'use strict';

  function SseEventEmitter() {
    var emitter = new RealtimeEventEmitter();
    var subscriberIds = [];
    var timeoutId = null;
    var eventSource = null;
    var firstTimeConnection = false;

    function setupEventHandling() {
      if (eventSource !== null) {
        eventSource.close();
      }
      eventSource = new window.EventSource(module.config().SSE_NOTIFIER_URL);
      eventSource.onopen = function() {
        if (firstTimeConnection) {
          Pubsub.publish('REALTIME_RECONNECTION_SUCCESS');
        }

        firstTimeConnection = true;
        Pubsub.publish('REALTIME_CONNECTION_SUCCESS');
      };
      eventSource.onmessage = function(e) {
        onPush(e);
      };
      eventSource.onerror = function() {
        Pubsub.publish('REALTIME_CONNECTION_FAILURE');
      };

    }

    function onPush(data) {
      if (subscriberIds.includes(data.data)) {
        emitter.onUpdate(data.data, null, data);
      }
    }

    function subscribesTo(id) {
      return subscriberIds.includes(id);
    }

    function collectingIds() { // eslint-disable-line no-unused-vars
      return timeoutId !== null;
    }

    function subscribeTo(id) {
      // keep only one subscription per id
      if (subscribesTo(id)) {
        return;
      }

      subscriberIds[subscriberIds.length] = id;
    }

    function unsubscribeFrom(id, version) { // eslint-disable-line no-unused-vars
      var index = subscriberIds.indexOf(id);
      if (index !== -1) {
        subscriberIds.splice(index, 1);
      }
    }

    setupEventHandling();

    return $.extend(emitter, {
      subscribeTo :  subscribeTo,
      unsubscribeFrom : unsubscribeFrom
    });

  }

  return SseEventEmitter

});

